<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>监控系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>监控系统</h2>
          <p>
            建设一个运行于统一平台、统一技术框架下的学校门户系统、管理信 息系统和教学资源管理系统及应用平台。 根据国示范建设中有关数字化校园建设的要求及我校实际情况，采用 走出去请进来，遵循面向服务架构（SOA）的设计原则进行系统的 需求分析、总体设计， 实现技术先进、高效稳定、安全可靠、信息 规范、数据完整的一体化数字化校园系统。消除信息孤岛和应用孤
            岛；支持师生教学与学习；支持学校决策和管理；支持数据信息共 建共享；为学校师生提供一站式管理服务；提高工作效率， 提高管 理效率，提高决策效率，提高信息利用率，提高核心竞争力。总体 水平达到省内一流，满足教学、科研和管理工作的需要。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>实时预览</h2>
          <p>视频实时预览即为对监控实时画面的预览，包括基础视频预 览、视频参数控制、视图模式的预览，平台与监控点所在的摄像机对讲通 道的实时对讲、批量广播以及对具备云台能力的监控点的实时云台控制。</p>
        </li>
        <li>
          <h2>录像回放</h2>
          <p>录像回放用于对历史视频录像的查询、定位、播放、录像 流控、片段下载等应用。</p>
        </li>
        <li>
          <h2>图片查询</h2>
          <p>WEB 端支持对配臵了抓图计划的监控点所抓历史图片的查 询，并按照监控点排序和时间排序两种方式展示图片查询结果；支持对 图片查询结果进行自动播放和下载操作，图片播放速度在 1 秒/张至 30 秒/张可配臵。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Ssmonitoringsystem',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
